import { Box, Typography } from "@mui/material";

export default function ShopitemzPrivacyEngPage() {
  return (
    <Box>
      <h1>Shopitemz Privacy Policy</h1>

      <p>
        Langue: <a href="shopitemz-privacy-policy-fr">français</a>
      </p>
      <h3>What is the Privacy Policy and what does it cover?</h3>
      <p>
        We at{" "}
        <b>
          <Typography component="span" color="primary">
            Shopitemz
          </Typography>
        </b>{" "}
        from <b>Podosoft</b>, do encourage you to read our Privacy Policy to
        help you use our Products in the way that’s right for you. <br />
        Our Privacy Policy ("Privacy Policy") helps explain our data practices,
        including the information we process to provide our Services. <br />
        For example, our Privacy Policy talks about what information we collect
        and how this affects you. It also explains the steps we take to protect
        your privacy, like securing your personal data and giving you control
        over who you communicate with on our Services.
        <br />
        This Privacy Policy applies to all of Shopitemz Services unless
        specified otherwise.
        <br />
        Respect for your privacy is the number one thing we want to help you
        with even if we give you the full responsibility of that. Since we
        started Shopitemz, late in 2023, we’ve build the service with a set of
        privacy principles in mind. In the following content, you’ll find :
      </p>

      <ul>
        <li>Additional Information On How We Handle Your Data</li>
        <li>Better Communication With People you connect with</li>
        <li>Making It Easier To Use</li>
      </ul>
      <br />

      <Typography component="h6" variant="h6" color="primary">
        Information We Collect
      </Typography>
      <p>
        Shopitemz must receive or collect some information to operate, provide,
        improve, understand, customize, support, and market our Services,
        including when you install, access, or use our Services.
        <br />
        The types of information we receive and collect depend on how you use
        our Services. We require certain information to deliver our Services and
        without this we will not be able to provide our Services to you. For
        example, you must provide your mobile phone number/email to create an
        account to use our Services.
        <br />
        Our Services have optional features which, if used by you, require us to
        collect additional information to provide such features. You will be
        notified of such collection, as appropriate. If you choose not to
        provide the information needed to use a feature, you will be unable to
        use the feature. For example, you cannot upload files if you do not
        permit storage access to/from your device. Permissions can be managed
        through your Settings menu on your devices.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Information You Provide
      </Typography>
      <p>
        <b>• Your Account Information.</b> You must provide your mobile phone
        number / email and basic information (including a profile name of your
        choice) to create a Shopitemz account. If you don’t provide us with this
        information, you will not be able to create an account to use our
        Services. You can add other information to your account, such as a
        profile picture and "about" information.
      </p>

      <p>
        <b>• Customer Support And Other Communications.</b> When you contact us
        for customer support or otherwise communicate with us, you may provide
        us with information related to your use of our Services, including
        copies of your text comments, any other information you deem helpful,
        and how to contact you (e.g., an email address). For example, you may
        send us an email with information relating to app performance or other
        issues.
      </p>
      <p>
        <b>• User Reports.</b> Just as you can report other users, other users
        or third parties may also choose to report to us your interactions; for
        example, to report possible violations of our Terms or policies. When a
        report is made, we collect information on both the reporting user and
        reported user. To find out more about what happens when a user report is
        made, please see
      </p>

      <Typography component="h6" variant="h6" color="primary">
        How We Use Information
      </Typography>

      <p>
        We use information we have (subject to choices you make and applicable
        law) to operate, provide, improve, understand, customize, support, and
        expand our Services. Here's how: <br />
        <br />
        <b>Our Services.</b> We use information we have to operate and provide
        our Services, including providing customer support; improving, fixing,
        and customizing our Services; We also use information we have to
        understand how people use our Services; evaluate and improve our
        Services; research, develop, and test new services and features; and
        conduct troubleshooting activities. We also use your information to
        respond to you when you contact us.
        <br />
        <br />
        <b>Safety, Security, And Integrity.</b> Safety, security, and integrity
        are an integral part of our Services. We use information we have to
        verify accounts and activity; combat harmful conduct; protect users
        against bad experiences and spam; and promote safety, security, and
        integrity on and off our Services, such as by investigating suspicious
        activity or violations of our Terms and policies, and to ensure our
        Services are being used legally.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Information You And We Share
      </Typography>
      <p>
        <b>• Information Associated With Your Account.</b> Your phone number,
        profile name and photo, and "about" information are available to anyone
        who uses our Services, although you can configure your Services settings
        to manage certain information available to other users, including
        businesses, with whom you communicate. Most importantly, you are
        responsible for any action you take on our platform, all we do is
        provide a tool for you to share products you are selling in your stores
        with people and communicate with them, but also be able to see what
        other people are selling.
      </p>

      <Typography component="h6" variant="h6" color="warning">
        Warnings{" "}
      </Typography>

      <p>
        If you share any information that we come to find inappropriate, we have
        the right to delete it and/or delete the account from wish it was
        published. below, you can find some types of information we find
        inappropriate: Sex or Nudity Content, Violence, Terrorism, Harassment,
        Fraud or scam, Injury, Hate speech, False information etc.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Updates To Our Policy
      </Typography>
      <p>
        We may amend or update our Privacy Policy. We will provide you notice of
        amendments to this Privacy Policy mainly by notification via the app, as
        appropriate, and update the “Last modified” date at the bottom of this
        Privacy Policy. Please review our Privacy Policy from time to time.
      </p>

      <p>last modified : Dec 13, 2024</p>
    </Box>
  );
}
